import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { client } from 'redux/redux'

import isNil from 'lodash/isNil'
import get from 'lodash/get'

import { ChildProps } from 'react-apollo'
import { InputProps } from './resetPasswordMutation'

import PageLayout from 'components/layout/pageLayout'
import SubNavigation from 'components/layout/subNavigation'
import Head from 'components/layout/head'
import Button from 'components/ui/button'
import Input from 'components/ui/input'

interface SettingsResetPasswordProps
  extends ChildProps<InputProps, Response>,
    RouteComponentProps<any> {
  dispatch: any
  resetPasswordMutation: any
}

interface IErrorObject {
  [k: string]: string | null
}

type SettingsResetPasswordState = {
  errors: IErrorObject | null
  success: boolean
  oldPassword: string | null
  newPassword: string | null
  newPasswordRepeat: string | null
}

class SettingsResetPassword extends Component<
  SettingsResetPasswordProps,
  SettingsResetPasswordState
> {
  constructor(props: SettingsResetPasswordProps) {
    super(props)
    this.state = {
      errors: null,
      success: false,
      oldPassword: null,
      newPassword: null,
      newPasswordRepeat: null,
    }
  }

  getValue = (key: string) => {
    const stateValue = get(this.state, key)

    return !isNil(stateValue) ? stateValue : ''
  }

  logout = () => {
    client.resetStore()
    localStorage.clear()
  }

  handlePasswordChange = () => {
    const { resetPasswordMutation: mutate } = this.props
    const { oldPassword, newPassword, newPasswordRepeat } = this.state

    const errors = {
      oldPassword: isNil(oldPassword) ? 'Error Message.' : null,
      newPassword:
        isNil(newPassword) || newPassword !== newPasswordRepeat ? 'Error Message.' : null,
      newPasswordRepeat:
        isNil(newPasswordRepeat) || newPassword !== newPasswordRepeat ? 'Error Message.' : null,
    }

    const hasErrors = Object.values(errors).find((error) => {
      if (error) return true
      return false
    })

    if (hasErrors) {
      this.setState({ errors, success: false })
    } else {
      if (mutate) {
        mutate({
          variables: { ...this.state },
        })
          .then((res: any) => {
            // Password reset was sucessfull
            if (get(res, 'data.resetPassword')) {
              this.setState({ errors: null, success: true })
              this.logout()
            } else {
              this.setState({
                errors: {
                  api: 'Error Message',
                },
                success: false,
              })
            }
          })
          .catch((err: any) => {
            this.setState({
              errors: {
                api: 'Error Message',
              },
              success: false,
            })
          })
      }
    }
  }

  render() {
    const { errors, success } = this.state

    return (
      <PageLayout pageTitle="Einstellungen">
        <Head
          headline="Einstellungen"
          subheadline={
            process.env.REACT_APP_ENV === 'rigips'
              ? 'Mengenermittlung und Systemsuche - HORST'
              : 'ABK calcKit – der Baukasten für die schnelle Kalkulation'
          }
          error={errors ? true : false}
          message={
            errors
              ? 'Passwort konnte nicht geändert werden!'
              : success
              ? 'Passwort geändert!'
              : undefined
          }
          actions={
            <Button primary onClick={this.handlePasswordChange}>
              Passwort ändern
            </Button>
          }
        />
        <SubNavigation
          items={[
            {
              label: 'Nutzerdaten',
              link: `/settings/user-data`,
            },
            {
              link: `/settings/logo`,
              label: 'Firmenlogo',
            },
            {
              link: `/settings/company-details`,
              label: 'Firmendaten',
            },
            {
              link: `/settings/reset-password`,
              label: 'Passwort ändern',
            },
            {
              link: `/settings/price-overview`,
              label: 'Preisübersicht',
            },
            {
              link: `/settings/time-overview`,
              label: 'Zeitenübersicht',
            },
          ]}
        />
        <div className="px-48 flex">
          {success ? (
            <div className="flex flex-col items-start">
              <p className="block font-400 text-15 tracking-0.1 text-black leading-22">
                Ihr Passwort wurde erfolgreich geändert. Bitte melden Sie sich erneut an.
              </p>
              <br></br>
              <Button secondary onClick={() => (window.location.href = '/login')}>
                Zum Login
              </Button>
            </div>
          ) : (
            <>
              <div className="w-4/12">
                <Input
                  type="password"
                  name="password"
                  label="Aktuelles Passwort"
                  value={this.getValue('oldPassword')}
                  leftAlign
                  error={errors && errors.oldPassword ? errors.oldPassword : undefined}
                  onChange={(value) => this.setState({ oldPassword: value ? String(value) : null })}
                />
              </div>
              <div className="w-4/12 ml-30">
                <Input
                  type="password"
                  name="newPassword"
                  label="Neues Passwort"
                  value={this.getValue('newPassword')}
                  leftAlign
                  error={errors && errors.newPassword ? errors.newPassword : undefined}
                  onChange={(value) => this.setState({ newPassword: value ? String(value) : null })}
                />
              </div>

              <div className="w-4/12 ml-30">
                <Input
                  type="password"
                  name="newPasswordRepeat"
                  label="Wiederholung neues Passwort"
                  value={this.getValue('newPasswordRepeat')}
                  leftAlign
                  error={errors && errors.newPasswordRepeat ? errors.newPasswordRepeat : undefined}
                  onChange={(value) =>
                    this.setState({ newPasswordRepeat: value ? String(value) : null })
                  }
                />
              </div>
            </>
          )}
        </div>
      </PageLayout>
    )
  }
}

export default SettingsResetPassword
